import {jsonMember, jsonObject} from 'typedjson';
import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";


/** запись в журнале запусков шедулера */

@jsonObject
export class BdpkScheduleLogItem extends DxGridRow {

  /** ID **/
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  /** Идентификатор расписания **/
  @jsonMember({name: "scheduleId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _scheduleId: number;

  /** Название расписания **/
  @jsonMember({name: "scheduleName", constructor: String, emitDefaultValue: false, isRequired: false })
  private _scheduleName: string;

  /** Идентификатор объекта **/
  @jsonMember({name: "objectId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _objectId: number;

  /** Название объекта **/
  @jsonMember({name: "objectName", constructor: String, emitDefaultValue: false, isRequired: false })
  private _objectName: string;

  /** Путь объекта **/
  @jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false })
  public objectFilePath: string;

  /** Фактическая дата и время запуска объекта **/
  @jsonMember({name: "runFactDateTime", constructor: Date, emitDefaultValue: false, isRequired: false })
  private _runFactDateTime: Date;

  /** Статус **/
  @jsonMember({name: "statusName", constructor: String, emitDefaultValue: false, isRequired: false })
  private _statusName: string;

  /**
   * Параметры запуска
   */
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  public parameters: string;

  /** Результат выполнения операции **/
  @jsonMember({name: "result", constructor: String, emitDefaultValue: false, isRequired: false })
  private _result: string;

  /** Комментарий, если произошла ошибка **/
  @jsonMember({name: "comment", constructor: String, emitDefaultValue: false, isRequired: false })
  private _comment: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  public runUser: string;

  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false })
  isCommentCutted: boolean;

  get is_commentCutted(): boolean {
    // пришлось закомментировать по усмотрению Еврения Корякина
    // return this.isCommentCutted;
    return !!this.comment;
  }

  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false })
  isResultCutted: boolean;

  get is_resultCutted(): boolean {
    // пришлось закомментировать по усмотрению Еврения Корякина
    // return this.isResultCutted;
    return !!this.result;
  }

  getRowId(): number {
    return this.id;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get scheduleId(): number {
    return this._scheduleId;
  }

  set scheduleId(value: number) {
    this._scheduleId = value;
  }

  get scheduleName(): string {
    return this._scheduleName;
  }

  set scheduleName(value: string) {
    this._scheduleName = value;
  }

  get objectId(): number {
    return this._objectId;
  }

  set objectId(value: number) {
    this._objectId = value;
  }

  get objectName(): string {
    return this._objectName;
  }

  set objectName(value: string) {
    this._objectName = value;
  }

  get runFactDateTime(): Date {
    return this._runFactDateTime;
  }

  set runFactDateTime(value: Date) {
    this._runFactDateTime = value;
  }

  get statusName(): string {
    return this._statusName;
  }

  set statusName(value: string) {
    this._statusName = value;
  }

  get result(): string {
    return this._result;
  }

  set result(value: string) {
    this._result = value;
  }

  get comment(): string {
    return this._comment;
  }

  set comment(value: string) {
    this._comment = value;
  }
}
